// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/traffic-call-phrasing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/traffic-call-phrasing/traffic-call-phrasing.js';

mount([g0]);
